{
  "layer_dwg": "couche au format DWG",
  "layer_kml": "couche au format KML",
  "drawing_units": "Unités de dessin",
  "coordinate_system": "Système de coordonnées",
  "advanced_rebase_options": "Options de rebase avancées",
  "source_latitude": "Latitude de la source",
  "source_longitude": "Longitude de la source",
  "target_x": "Cible X",
  "target_y": "Cible Y",
  "target_rotation": "Rotation de la cible (degrés)",
  "export_dwg": "Exporter un fichier DWG",
  "route_convert_line": "Convertir en ligne",
  "route_convert_confirmation": {
    "title": "Convertir un itinéraire en ligne",
    "message": "Êtes-vous sûr de vouloir convertir cet itinéraire en ligne ? Cette action ne peut pas être annulée."
  },
  "styles": {
    "lineTypes": {
      "dotted": "En pointillé",
      "smallDash": "Petit pointillé",
      "largeDash": "Gros pointillés"
    }
  },
  "no_copy_empty_group": "Impossible de copier : la sélection ne contient aucune couche",
  "map_group_status": {
    "title": "Groupes de couches/groupes",
    "explain": "Regroupez les couches et les autres groupes",
    "nested_level": "Les groupes ne peuvent avoir que 3 niveaux de profondeur",
    "parent": "Les articles ne peuvent pas appartenir à des groupes différents",
    "amount": "Sélectionnez au moins un élément pour activer le regroupement",
    "type": "La sélection ne doit pas contenir d'objets cartographiques",
    "loading": "Attendez que le chargement de la carte soit terminé",
    "permissions": "Autorisation « Accès complet » sur le forfait requise pour activer le regroupement"
  },
  "map_unlink_status": {
    "title": "Dissocier les couches",
    "explain": "Détache et copie les couches de leur plan d'origine",
    "amount": "Sélectionnez au moins une couche liée pour activer la dissociation des couches",
    "type": "La sélection ne doit contenir que des couches liées",
    "loading": "Attendez que le chargement de la carte soit terminé",
    "permissions": "L'autorisation « Modifier » sur le plan est requise pour dissocier les couches"
  },
  "copy_status": {
    "title": "Copier des couches/groupes",
    "explain": "Fait une copie des couches et des groupes sélectionnés",
    "amount": "Sélectionnez au moins une couche pour activer la copie de couches",
    "type": "La sélection ne doit contenir que des couches et des groupes",
    "loading": "Attendez que le chargement de la carte soit terminé",
    "permissions": "L'autorisation « Modifier » sur le plan est requise pour copier des couches et des groupes"
  },
  "map_delete_status": {
    "title": "Supprimer des couches/groupes",
    "explain": "Supprime les couches et les groupes sélectionnés",
    "amount": "Sélectionnez au moins une couche ou un groupe pour activer la suppression",
    "type": "La sélection ne doit contenir que des couches et des groupes",
    "loading": "Attendez que le chargement de la carte soit terminé",
    "permissions": "Autorisation « Admin » sur les couches requise pour supprimer des couches et des groupes"
  },
  "mapBackgroundError": {
    "title": "Fond de carte non disponible",
    "part1": "Nous n'avons pas pu charger le",
    "part2": "arrière-plan, nous sommes donc passés à un autre. Veuillez essayer",
    "part3": "encore une fois plus tard."
  },
  "qrCode": {
    "copySuccess": "Code QR copié dans le presse-papiers",
    "copyError": {
      "title": "Impossible de copier le code QR",
      "message": "Veuillez réessayer ou utiliser l'option de téléchargement"
    },
    "downloadSuccess": {
      "title": "Code QR téléchargé",
      "message": "Vérifiez votre dossier de téléchargements"
    },
    "downloadError": {
      "title": "Impossible de télécharger le code QR",
      "message": "Veuillez réessayer"
    }
  },
  "splitLines": {
    "title": "Ligne divisée",
    "selectMapObject": "Sélectionnez une seule ligne à scinder",
    "lockedLayer": "Impossible de diviser la ligne : la couche est verrouillée",
    "linesOnly": "Seuls les objets linéaires peuvent être divisés",
    "fixedShapes": "Impossible de fractionner des lignes de forme fixe",
    "drawing": "Impossible de diviser la ligne pendant le dessin",
    "action": "Cliquez pour diviser la ligne",
    "confirmMessage": "Êtes-vous sûr de vouloir diviser cette ligne ? Cette action ne peut pas être annulée.",
    "tooltipStart": "Depuis le début",
    "tooltipEnd": "Pour terminer"
  }
}